import BaseAPI from "../api";

const path: string = "/edpex-responsible";

export type listType = {
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class edpexResponsibleAPI extends BaseAPI {
  static getEdpexResponsibleList(query: listType): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }

  static getEdpexResponsibleById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static createEdpexResponsible(body: any): Promise<any> {
    return this.api.post(`${path}/`, body);
  }

  static updateEdpexResponsible(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteEdpexResponsible(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}
